import Entity from "./Entity";
import IUser from "./User";
import ISubscription from "./Subscription";
import IBankBillet from "./BankBillet";

export default interface IInstallment extends Entity {
	value?: number | any;
	user?: IUser;
	status?: InstallmentStatus | any;
	number?: number;
	paymentDate?: Date;
	subscription?: ISubscription | any;
	zoopId?: string;
	transaction?: string | IBankBillet;
}

export enum InstallmentStatus {
	pending = 0,
	paid = 1
}
